import React from "react";
import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Tfoot,
  Th,
  Thead,
  Tr,
  Box,
  Skeleton,
  Button,
  Link,
  SkeletonCircle,
  SkeletonText,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { flexRender } from "@tanstack/react-table";

function FarmerTable({ farmersData, isLoaded, columns, table }) {
  const navigate = useNavigate();

  return (
    <TableContainer className="overflow-style" overflowX={"scroll"}>
      <Table
        size="md"
        bg={"#fff"}
        borderRadius={"15px"}
        // className="overflow-style"
        // overflowX={"scroll"}
      >
        <Thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <Tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => {
                // see https://tanstack.com/table/v8/docs/api/core/column-def#meta to type this correctly
                const meta = header.column.columnDef.meta;
                return (
                  <Th
                    key={header.id}
                    onClick={header.column.getToggleSortingHandler()}
                    isNumeric={meta?.isNumeric}
                  >
                    {flexRender(
                      header.column.columnDef.header,
                      header.getContext()
                    )}
                    {/* 
                  <chakra.span pl="4">
                    {header.column.getIsSorted() ? (
                      header.column.getIsSorted() === "desc" ? (
                        <TriangleDownIcon aria-label="sorted descending" />
                      ) : (
                        <TriangleUpIcon aria-label="sorted ascending" />
                      )
                    ) : null}
                  </chakra.span> */}
                  </Th>
                );
              })}
            </Tr>
          ))}
        </Thead>
        <Tbody>
          {!isLoaded ? (
            <>
              <Tr>
                <Td>
                  <Skeleton height="20px" fadeDuration={1} />
                </Td>
                <Td>
                  <Skeleton height="20px" fadeDuration={1} />
                </Td>
                <Td>
                  <Skeleton height="20px" fadeDuration={1} />
                </Td>
                <Td>
                  <Skeleton height="20px" fadeDuration={1} />
                </Td>
                <Td>
                  <Skeleton height="20px" fadeDuration={1} />
                </Td>
              </Tr>
              <Tr>
                <Td>
                  <Skeleton height="20px" fadeDuration={1} />
                </Td>
                <Td>
                  <Skeleton height="20px" fadeDuration={1} />
                </Td>
                <Td>
                  <Skeleton height="20px" fadeDuration={1} />
                </Td>
                <Td>
                  <Skeleton height="20px" fadeDuration={1} />
                </Td>
                <Td>
                  <Skeleton height="20px" fadeDuration={1} />
                </Td>
              </Tr>
              <Tr>
                <Td>
                  <Skeleton height="20px" fadeDuration={1} />
                </Td>
                <Td>
                  <Skeleton height="20px" fadeDuration={1} />
                </Td>
                <Td>
                  <Skeleton height="20px" fadeDuration={1} />
                </Td>
                <Td>
                  <Skeleton height="20px" fadeDuration={1} />
                </Td>
                <Td>
                  <Skeleton height="20px" fadeDuration={1} />
                </Td>
              </Tr>
              <Tr>
                <Td>
                  <Skeleton height="20px" fadeDuration={1} />
                </Td>
                <Td>
                  <Skeleton height="20px" fadeDuration={1} />
                </Td>
                <Td>
                  <Skeleton height="20px" fadeDuration={1} />
                </Td>
                <Td>
                  <Skeleton height="20px" fadeDuration={1} />
                </Td>
                <Td>
                  <Skeleton height="20px" fadeDuration={1} />
                </Td>
              </Tr>
            </>
          ) : (
            <>
              {table.getRowModel()?.rows?.map((row) => (
                <Tr key={row?.id}>
                  {row.getVisibleCells().map((cell) => {
                    // see https://tanstack.com/table/v8/docs/api/core/column-def#meta to type this correctly
                    const meta = cell?.column?.columnDef?.meta;
                    return (
                      <Td key={cell?.id} isNumeric={meta?.isNumeric}>
                        {cell?.renderValue() === "actions" ? (
                          <Link
                            color={"#3958DC"}
                            fontWeight="800"
                            onClick={() =>
                              navigate(
                                `/supplier/farmer-details/${cell?.row.original?._id}`
                              )
                            }
                          >
                            View Details
                          </Link>
                        ) : (
                          flexRender(
                            cell?.column?.columnDef?.cell,
                            cell?.getContext()
                          )
                        )}
                      </Td>
                    );
                  })}
                </Tr>
              ))}
            </>
          )}
        </Tbody>
        <Tfoot>
          {/* <Tr>
          <Th>To convert</Th>
          <Th>into</Th>
          <Th isNumeric>multiply by</Th>
        </Tr> */}
        </Tfoot>
      </Table>
    </TableContainer>
  );
}

export default FarmerTable;
